// extracted by mini-css-extract-plugin
export default {"exchange_d":"Exchange_exchange_d__5-Mox","exchange_l":"Exchange_exchange_l__4mXp7","exchange_grids":"Exchange_exchange_grids__cFJZO"};